import OrgSelectorDemo from "src/components/common/Org-selector";

export default function OrgSelector() {
  return <OrgSelectorDemo />;
}